import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { TreatmentRow } from "@/lib/database.types";

export function useTreatments(patientId: string | undefined) {
  return useQuery<TreatmentRow[]>({
    queryKey: ["treatments", patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("treatments")
        .select(
          "*, provider:providers(id,full_name), shipments(id,treatment_id,carrier,tracking_number,status,shipped_at,delivered_at,created_at)",
        )
        .eq("patient_id", patientId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return (data as TreatmentRow[] | null) ?? [];
    },
  });
}
